import { useState } from 'react'
import { Share2, Link as LinkIcon, Check, Facebook, Twitter, Linkedin } from 'lucide-react'

import { SCHEDULE_SERIES_NAME } from '../../utils/masterclassSchedule'

function defaultUrl(slug) {
  return `${window.location.origin}/masterclass/${slug}`
}

export default function ShareEvent({ slug, url: urlProp, title, summary }) {
  const [copied, setCopied] = useState(false)
  const [open, setOpen] = useState(false)
  const url = urlProp || (slug ? defaultUrl(slug) : window.location.href)
  const text = encodeURIComponent(title || SCHEDULE_SERIES_NAME)
  const encodedUrl = encodeURIComponent(url)
  const encodedSummary = encodeURIComponent(summary || '')

  const copy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="cinema-btn-ghost inline-flex items-center gap-2"
        aria-label="Share"
      >
        <Share2 className="w-4 h-4" /> Share
      </button>
      {open && (
        <div className="absolute top-full right-0 mt-3 z-20 w-64 p-4 cinema-glass-elevated rounded-lg shadow-xl">
          <p className="text-white font-sans text-sm font-medium mb-3">Share this masterclass</p>
          <div className="flex gap-2 mb-3">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
              target="_blank"
              rel="noreferrer"
              className="p-2.5 bg-[#1877F2]/20 text-[#1877F2] rounded hover:bg-[#1877F2]/30 transition-colors"
              aria-label="Share on Facebook"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${text}`}
              target="_blank"
              rel="noreferrer"
              className="p-2.5 bg-sky-500/20 text-sky-400 rounded hover:bg-sky-500/30 transition-colors"
              aria-label="Share on Twitter"
            >
              <Twitter className="w-4 h-4" />
            </a>
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}&summary=${encodedSummary}`}
              target="_blank"
              rel="noreferrer"
              className="p-2.5 bg-[#0A66C2]/20 text-[#0A66C2] rounded hover:bg-[#0A66C2]/30 transition-colors"
              aria-label="Share on LinkedIn"
            >
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
          <button
            onClick={copy}
            className="w-full flex items-center justify-center gap-2 px-3 py-2 text-sm font-sans text-white bg-white/5 border-b border-white/10 rounded hover:bg-white/10 transition-colors"
          >
            {copied ? <Check className="w-4 h-4 text-green-400" /> : <LinkIcon className="w-4 h-4" />}
            {copied ? 'Copied!' : 'Copy Link'}
          </button>
        </div>
      )}
    </div>
  )
}
